import React, { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import XanoAPI from "../lib/XanoAPI";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
// eslint-disable-next-line import/no-unresolved
import Logo from "../images/logo.png";
import { Icons } from "./icons";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="h-32 w-32 flex flex-col justify-center items-center">
        <img src={Logo} alt="logo" className="h-16 w-16 mb-4" />
        <Icons.spinner className="mr-2 h-6 w-6 animate-spin center" />
      </div>
    </div>
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, hasTOTPWarning } = useAuth();
  const api = XanoAPI.getInstance();
  const [dialogOpen, setDialogOpen] = useState(false);

  React.useEffect(() => {
    if (
      hasTOTPWarning &&
      window.location.pathname !== "/account/two-factor-authentication/"
    ) {
      setDialogOpen(true); // Open the dialog if TOTP is required
    }
  }, [hasTOTPWarning]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    api.signOut();
    // Redirect to sign-in if unauthenticated
    return null;
  }

  return (
    <>
      {/* TOTP Warning Dialog */}
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Enable Two-Factor Authentication</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground">
            Two-Factor Authentication (TOTP) is required for your account.
            Please enable it to ensure your account's security.
          </p>
          <DialogFooter>
            <Button
              onClick={() => {
                setDialogOpen(false);
                window.location.href = "/account/two-factor-authentication/";
              }}
              className="w-full"
            >
              Enable Two-Factor Authentication
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Protected Content */}
      {children}
    </>
  );
};

export default ProtectedRoute;
